import { render } from "./NotFoundComponent.vue?vue&type=template&id=2b13f773&scoped=true"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js"

import "./NotFoundComponent.vue?vue&type=style&index=0&id=2b13f773&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b13f773"],['__file',"resources/js/components/NotFoundComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b13f773"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b13f773', __exports__)) {
    api.reload('2b13f773', __exports__)
  }
  
  module.hot.accept("./NotFoundComponent.vue?vue&type=template&id=2b13f773&scoped=true", () => {
    api.rerender('2b13f773', render)
  })

}


export default __exports__